import selectReadReceiptOption from '../actions/selectReadReceiptOption';
import ReadReceiptsOptionState from '../store/schema/ReadReceiptOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import ReadReceiptResponse from 'owa-service/lib/contract/ReadReceiptResponse';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

export interface ReadReceiptsFullProps {
    optionStore?: ReadReceiptsOptionState;
    userOptions?: UserOptionsType;
}

// This interface is here to catch any changes in the ReadReceiptResponse type, as used by this class for choice keys.
interface ReadReceiptChoice {
    key: ReadReceiptResponse;
    text: string;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class ReadReceiptsFull extends React.Component<ReadReceiptsFullProps, {}> {
    render() {
        let { optionStore, userOptions } = this.props;

        let selectedKey = getFallbackValueIfNull(
            optionStore.readReceiptResponse,
            userOptions.ReadReceipt
        );

        let choices: ReadReceiptChoice[] = [
            {
                key: 'DoNotAutomaticallySend',
                text: strings.options_mail_ReadReceiptPrompt,
            },
            {
                key: 'AlwaysSend',
                text: strings.options_mail_ReadReceiptAlways,
            },
            {
                key: 'NeverSend',
                text: strings.options_mail_ReadReceiptNever,
            },
        ];

        return (
            <ChoiceGroup
                selectedKey={selectedKey}
                options={choices}
                onChange={this.onChange}
                label={strings.options_mail_ReadReceiptTitle}
            />
        );
    }

    private onChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectReadReceiptOption(option.key as ReadReceiptResponse);
    };
}
